export default "__VITE_ASSET__a278cc18__"